import React from 'react';
import { Link } from 'react-router-dom';

export function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h2 className="text-4xl font-bold text-gray-800 mb-8">About AlpharettaKidsEvents</h2>

      <div className="space-y-8">
        {/* Mission */}
        <section className="bg-white rounded-lg shadow-md p-8">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">🎯 Our Mission</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            AlpharettaKidsEvents was created to help busy parents and caregivers discover fun,
            family-friendly activities happening in Alpharetta and the surrounding areas. We
            believe every child deserves access to enriching experiences, and every parent
            deserves an easy way to find them.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Our platform aggregates events from local libraries, parks, community centers,
            churches, and other organizations, giving you a comprehensive view of what's
            happening each day.
          </p>
        </section>

        {/* Features */}
        <section className="bg-white rounded-lg shadow-md p-8">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">✨ Features</h3>
          <ul className="space-y-3 text-gray-700">
            <li className="flex gap-3">
              <span>📅</span>
              <span><strong>Today's View:</strong> See what's happening today at a glance</span>
            </li>
            <li className="flex gap-3">
              <span>📆</span>
              <span><strong>Calendar:</strong> Browse events by month and plan ahead</span>
            </li>
            <li className="flex gap-3">
              <span>🗺️</span>
              <span><strong>Location Info:</strong> Quick access to maps and directions</span>
            </li>
            <li className="flex gap-3">
              <span>📝</span>
              <span><strong>Submit Events:</strong> Share your own event with the community</span>
            </li>
            <li className="flex gap-3">
              <span>📱</span>
              <span><strong>Mobile-Friendly:</strong> Works great on phones and tablets</span>
            </li>
          </ul>
        </section>

        {/* How It Works */}
        <section className="bg-white rounded-lg shadow-md p-8">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">🔄 How It Works</h3>
          <p className="text-gray-700 mb-4">
            Our system automatically updates nightly, pulling event information from:
          </p>
          <ul className="space-y-2 text-gray-700 ml-4">
            <li>✓ Eventbrite API</li>
            <li>✓ Google Calendar & ICS feeds</li>
            <li>✓ Local library calendars</li>
            <li>✓ Parks & Recreation websites</li>
            <li>✓ Community center schedules</li>
            <li>✓ Church event calendars</li>
            <li>✓ User submissions (moderated)</li>
          </ul>
        </section>

        {/* Contact & Support */}
        <section className="bg-white rounded-lg shadow-md p-8">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">💬 Contact & Support</h3>
          <p className="text-gray-700 mb-4">
            Have a question? Found an event that should be on our calendar? Found an error?
          </p>
          <div className="bg-pink-50 border border-pink-200 rounded p-4 mb-4">
            <p className="text-gray-800">
              <strong>Email:</strong> info@alpharettakidsevents.com
            </p>
          </div>
          <p className="text-gray-700">
            You can also <Link to="/submit" className="text-pink-500 hover:text-pink-600 font-semibold">
              submit an event
            </Link> if you know of activities we're missing!
          </p>
        </section>

        {/* Privacy & Terms */}
        <section className="bg-white rounded-lg shadow-md p-8">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">📋 Privacy & Terms</h3>
          <p className="text-gray-700 mb-4">
            We respect your privacy. We do not sell your information or use tracking cookies
            for advertising. We only collect information you voluntarily submit.
          </p>
          <div className="space-y-2 text-sm">
            <p className="text-gray-600">
              <button onClick={() => {}} className="text-pink-500 hover:text-pink-600">
                Privacy Policy
              </button>
            </p>
            <p className="text-gray-600">
              <button onClick={() => {}} className="text-pink-500 hover:text-pink-600">
                Terms of Service
              </button>
            </p>
          </div>
        </section>

        {/* Call to Action */}
        <section className="bg-gradient-to-r from-pink-500 to-orange-500 rounded-lg shadow-md p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Ready to explore?</h3>
          <p className="mb-6">Check out today's events or browse our calendar!</p>
          <div className="flex gap-4 justify-center">
            <Link
              to="/"
              className="bg-white text-pink-600 hover:bg-pink-50 px-6 py-2 rounded font-semibold transition"
            >
              Today's Events
            </Link>
            <Link
              to="/calendar"
              className="bg-white text-pink-600 hover:bg-pink-50 px-6 py-2 rounded font-semibold transition"
            >
              Calendar
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
